const fonts = [{ family: "Chivo", weights: [100, 400, 600, 800, 900], styles: ["normal"] }];

export default fonts;
